import React from "react";
import { Link } from "react-router-dom";
import { FiMinus, FiPlus } from "react-icons/fi";
import { siteConfig } from "../Datas/productData";
import "../css/footer.scss";

const footerGroups = [
  {
    title: "Shop",
    links: [
      ["Shopping bag", "/cartpage"],
      ["Wishlist", "/shop?view=wishlist"],
      ["Women", "/shop?gender=Women"],
      ["Men", "/shop?gender=Men"],
    ],
  },
  {
    title: "Customer service",
    links: [
      ["Contact us", "/contact"],
      ["Orders and cancellations", "/orders-cancellations"],
      ["Payments and security", "/payments-security"],
      ["Returns and exchanges", "/returns"],
      ["Shipping", "/shipping"],
      ["Product care and quality", "/product-care"],
      ["FAQs", "/faqs"],
    ],
  },
  {
    title: "Shopping policies",
    links: [
      ["Consumer rights", "/consumer-rights"],
      ["Pricing and promotions", "/promotions"],
      ["Fraud prevention", "/fraud-prevention"],
      ["Electronic communications", "/electronic-communications"],
      ["Our approach", "/about"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Legal and policy centre", "/legal"],
      ["Terms and conditions", "/terms"],
      ["Privacy policy", "/privacy"],
      ["Privacy choices", "/privacy-choices"],
      ["Cookie policy", "/cookie-policy"],
      ["Accessibility statement", "/accessibility"],
      ["Acceptable use", "/acceptable-use"],
      ["Intellectual property", "/intellectual-property"],
      ["Legal notice and contact", "/legal-notice"],
    ],
  },
];

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-menu">
        <div className="footer-navigation">
          {footerGroups.map((group) => (
            <details className="footer-group" key={group.title}>
              <summary>
                <span>{group.title}</span>
                <FiPlus className="footer-group__plus" aria-hidden="true" />
                <FiMinus className="footer-group__minus" aria-hidden="true" />
              </summary>
              <nav className="footer-group__links" aria-label={group.title}>
                {group.links.map(([label, path]) => (
                  <Link key={label} to={path}>
                    {label}
                  </Link>
                ))}
              </nav>
            </details>
          ))}
        </div>

        <section
          className="footer-newsletter"
          aria-labelledby="footer-help-title"
        >
          <h2 id="footer-help-title">Customer care</h2>
          <p>Questions about products, delivery or an order?</p>
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          <address>{siteConfig.contact.address}</address>
          <div
            className="footer-payment-methods"
            aria-label="Supported payment methods"
          >
            <span>Visa</span>
            <span>Mastercard</span>
            <span>American Express</span>
            <span>Apple Pay</span>
            <span>Google Pay</span>
          </div>
        </section>
      </div>

      <div className="footer-meta">
        <p>{siteConfig.brandName} is part of an independent design studio.</p>
        <div>
          <span>
            {siteConfig.contact.email} · {siteConfig.contact.address}
          </span>
          <span>Hong Kong / English</span>
          <span>
            &copy; {new Date().getFullYear()} {siteConfig.brandName}
          </span>
        </div>
      </div>

      <Link
        className="footer-wordmark"
        to="/"
        aria-label={`${siteConfig.brandName} home`}
      >
        {siteConfig.logo}
      </Link>
    </footer>
  );
}

export default Footer;
